import { MessageBox } from "@jutro/ui";
import { ComponentProps } from "react";
import { VisitsWithDeletedShiftData } from "components/VisitsWithDeletedShiftTable/types";

export const tileModeMessageBoxContentMap: Record<
  VisitsWithDeletedShiftData["mode"],
  Omit<ComponentProps<typeof MessageBox>, "full">
> = {
  all: {
    color: "orange",
    text: "Wybierz pozycję na liście, żeby edytować nadchodzącą wizytę",
  },
  afterDeletedShift: {
    color: "rose",
    text: "Pacjenci zarezerwowali już wizyty w czasie zmian, które zostały usunięte z Planera Pracy. Wybierz pozycję na liście, żeby edytować wizytę",
  },
};
